import $ from 'jquery';
import axios from 'axios';


var Plugin, defaults, pluginName;
pluginName = "multiform";
defaults = {
};

Plugin = (function () {

    class Plugin {
        constructor(element, options) {
            this.element = element;
            this.$el = $(this.element);
            this.settings = $.extend({}, defaults, options);
            this.$dest = this.$el.find('[data-js-multiform="destination"]');
            this.$add = this.$el.find('[data-js-multiform="add"]');
            this.formlet = this.$el.find('[data-js-multiform="formlet"]').clone()[0].outerHTML;
            this.$button = this.$el.find('[data-js-multiform="button"]');
            this._name = pluginName;
            this.init();
        }

        init() {
            this.$add.on('click', $.proxy(this.onAdd, this));
            this.$el.on('click','[data-js-multiform="remove"]',this.onRemove.bind(this));
            this.$button.on('click',this.submitForms.bind(this));
        }

        onAdd() {
            this.$dest.append($(this.formlet));
        }

        onRemove(e){
            this.removeFormlet($(e.currentTarget));
        }

        submitForms() {
            this.$el.find('form').each((i,form)=>{
                if(!HTMLFormElement.prototype.reportValidity || form.reportValidity()){
                    const $form = $(form);
                    const serializedForm = $form.serialize();

                    axios.post($form.prop('action'),serializedForm).then(()=>{
                        this.removeFormlet($form);
                        if(this.$el.find('form').length === 0){
                            window.location = "/admin/hcps";
                        }

                    }).catch((error)=> {
                        // handle errors
                        if (error.response && error.response.status === 422) {
                            this.handleErrors(error.response.data.errors,$form);
                        }
                    })
                }

            });
        }

        handleErrors(errors,$form){

            $form.find('.form__error').remove();

            Object.keys(errors).forEach((key)=>{
                const error =  errors[key][0];
                $form.find(`[name="${key}"]`).after(`<span class='form__error'>${error}</span>`);
            });
        }

        removeFormlet($el){
            $el.closest('[data-js-multiform="formlet"]').remove();
        }

    }

    return Plugin;

})();
$.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!$.data(this, "plugin_" + pluginName)) {
            return $.data(this, "plugin_" + pluginName, new Plugin(this, options));
        }
    });
};

$(document).ready(()=>{
    const $multiform = $('[data-js-multiform="container"]');
    if ($multiform.length) {
        $multiform.each(init);
    }
})

function init() {
    var $this = $(this);
    $this.multiform();
}
